import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { GlobalsService } from 'src/app/services/globals/globals.service';

@Component({
  selector: 'app-add-things-dialog',
  templateUrl: './add-things-dialog.component.html',
  styleUrls: ['./add-things-dialog.component.scss'],
})
export class AddThingsDialogComponent implements OnInit {
  public breakpoint: number; // Breakpoint observer code
  public name: string = `Melodic-Opaque-Salamander`;

  public snr: string = `10000000935b2d16`;
  public cpuId: string = `abcdef1234567891`;
  public ethMac: string = `f5:5f:01:5d:95:82`;

  public ethMac1: string = `1`;

  public addThingsForm: FormGroup;
  wasFormChanged = false;

  options: FormGroup;
  macEthCntrl = new FormControl('');
  snrControl = new FormControl('');
  cpuControl = new FormControl('');

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private api: ApiService,
    private _snackBar: MatSnackBar,
    public router: Router,
    private globals: GlobalsService
  ) {
    this.options = fb.group({
      macEth: this.macEthCntrl,
      snr: this.snrControl,
      cpu: this.cpuControl,
    });
  }

  public ngOnInit(): void {
    this.addThingsForm = this.fb.group({
      // deviceName: [this.name, [Validators.pattern('[a-zA-Z]+([a-zA-Z ]+)*')]],
      // deviceSerialNumber: [this.snr, [Validators.pattern('[a-zA-Z]+([a-zA-Z ]+)*')]]
      mac: [this.ethMac, []],
    });
    this.breakpoint = window.innerWidth <= 600 ? 1 : 2; // Breakpoint observer code
  }

  public onAddUser(): void {
    this.markAsDirty(this.addThingsForm);
  }

  openDialog(): void {
    if (this.addThingsForm.dirty) {
      // const dialogRef = this.dialog.open(DeleteComponent, {
      //   width: '340px',
      // });
    } else {
      this.dialog.closeAll();
    }
  }

  // tslint:disable-next-line:no-any
  public onResize(event: any): void {
    this.breakpoint = event.target.innerWidth <= 600 ? 1 : 2;
  }

  private markAsDirty(group: FormGroup): void {
    group.markAsDirty();
    // tslint:disable-next-line:forin
    for (const i in group.controls) {
      group.controls[i].markAsDirty();
    }
  }

  formChanged() {
    this.wasFormChanged = true;
  }

  addDeviceToList() {}

  commissionDevice() {
    //Check values are filled

    if (
      this.snrControl.value &&
      this.snrControl.value != '' &&
      this.cpuControl.value &&
      this.cpuControl.value != '' &&
      this.macEthCntrl.value &&
      this.macEthCntrl.value != ''
    ) {
      //Commision device

      let data = [
        {
          serial: this.snrControl.value,
          eth_mac: this.macEthCntrl.value,
          cpu_id: this.cpuControl.value,
        },
      ];

      this.api.commissionDevices(
        data,
        'proton',
        (data?: any) => {
          //Success
          if (data && data.success && data.success == 1) {
            //Show success
            this._snackBar.open(`Successfully added device.`, 'Close');

            //Route to dashboard
            this.globals.selectedSidenav = 'Dashboard';
            this.router.navigate(['dashboard']);
            //Close dialog
            this.dialog.closeAll();
          } else {
            // show failure and reason
            this._snackBar.open(
              `Device add failed. Reason: ${
                data.devices && data.devices[0] && data.devices[0].reason
                  ? data.devices[0].reason
                  : 'Unknown'
              }.`,
              '',
              { duration: 5000 }
            );
          }
        },
        () => {
          //Failure
        }
      );
    } else {
      //Error
      this._snackBar.open(
        `Please fill all fields.`,
        '',
        this.globals.snackbarConfig
      );
    }
  }
}
